import React from 'react'
import EmployeeStartEndDate from './EmployeeStartEndDate'
import css from './card.module.scss'
import { IBooking, IDepartment, ISpace } from '@api'
import { Avatar, Link } from '@ui'
import { DateUtil } from '@utils'
import { Size } from '@ui/Avatar'

const EmployeeBookingCard = ({
  booking,
  space,
  timezone,
  selectEmployee = () => {},
  locateEmployee,
  showEmail,
}: {
  booking: IBooking
  space?: ISpace
  timezone: string
  selectEmployee?: () => void
  locateEmployee?: () => void
  showEmail: boolean
}) => {
  const {
    employee: { name, dept, email, team, assets },
  } = booking
  let spaceEl = null
  const startDate = DateUtil.tz(booking.startDate, timezone)
  const endDate = DateUtil.tz(booking.endDate, timezone)

  if (space) {
    spaceEl = locateEmployee ? (
      <div className={`${css.small} ${css.ellipsis}`}>
        <Link onClick={locateEmployee}>{space.externalId}</Link>
      </div>
    ) : (
      <div className={`${css.small} ${css.ellipsis}`}>{space.externalId}</div>
    )
  }

  return (
    <EmployeeDetailCard
      email={email}
      name={name}
      showEmail={showEmail}
      avatar
      avatarProps={{ size: Size.SM }}
      selectEmployee={selectEmployee}
      smallText={
        <EmployeeStartEndDate
          dateFormat="MMM dd, h:mm a"
          startDate={startDate}
          endDate={endDate}
          showTooltip={true}
        />
      }
      section={
        dept && (
          <div className={`${css.small} ${css.ellipsis}`}>
            {formatDepartmentName(dept, team as IDepartment | undefined)}
          </div>
        )
      }
    />

    // <div className={css.employeeCard} onClick={selectEmployee}>
    //   <div className={css.icon}>
    //     <Avatar name={name} assets={assets} />
    //   </div>
    //   <div className={css.text}>
    //     <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
    //       <div className={`${css.large} ${css.ellipsis}`}>{name}</div>
    //       {showEmail && renderEmail()}
    //       <div className={css.small}>
    //         <EmployeeStartEndDate
    //           dateFormat="MMM dd, h:mm a"
    //           startDate={startDate}
    //           endDate={endDate}
    //           showTooltip={true}
    //         />
    //       </div>
    //     </div>
    //     {dept && (
    //       <div className={`${css.small} ${css.ellipsis}`}>
    //         {formatDepartmentName(dept, team as IDepartment | undefined)}
    //       </div>
    //     )}
    //   </div>
    // </div>
  )
}

export const EmployeeDetailCard = ({
  name,
  email,
  showEmail = true,
  avatar,
  smallText,
  section,
  selectEmployee = () => {},
  avatarProps = {},
}: {
  name: string
  email?: string
  showEmail?: boolean
  smallText?: JSX.Element
  avatar?: boolean
  section?: JSX.Element
  selectEmployee?: () => void
  avatarProps?: any
}) => {
  const renderEmail = () => {
    if (!email) {
      return null
    }

    if (showEmail) {
      return (
        <a className={css.email} href={`mailto:${email}`}>
          {email}
        </a>
      )
    }
  }
  return (
    <div className={`${css.employeeCard}`} onClick={selectEmployee}>
      {avatar && (
        <div className={css.icon}>
          <Avatar name={name} size={avatarProps.size || Size.XXS} style={avatarProps.style || {}} />
        </div>
      )}
      <div className={css.text}>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
          <div className={`${css.ellipsis}`}>{name}</div>
        </div>
        {renderEmail()}
        {smallText && <div className={`${css.small} ${css.ellipsis}`}>{smallText}</div>}
      </div>
      {section}
    </div>
  )
}

function formatDepartmentName(department: IDepartment, team?: IDepartment) {
  return team ? `${department.name} | ${team.name}` : department.name
}

export default EmployeeBookingCard
